exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RichTextEditor-module__editor___1O82r{border:none!important}.RichTextEditor-module__editor___1O82r button{background-color:#ececec;border:none}.RichTextEditor-module__editor___1O82r span{font-size:14px!important;font-family:Circe!important}", ""]);

// exports
exports.locals = {
	"editor": "RichTextEditor-module__editor___1O82r"
};